export enum PDFColor {
  Black = '#000',
  White = '#FFF',
  Grey = '#444',
  LightGrey = '#888',
  Primary = '#2A7DE1',
  Secondary = '#00358E',
  PaleBlue = '#ecf3f6',
}
